// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2jHJQ","detailsBorder":"styles_detailsBorder__T6G3x"};